/**
 * Feel Awsm · Schlaf Esenz Funnel
 * Scoped to #feelawsm-sleep-funnel (Shopify-safe, Dawn pattern).
 * ATC mirrors assets/product-form.js (sections in POST, XHR for selling plans, renderContents + open).
 * v1 — initial build (adapted from Kollagen Elixier baseline)
 */
(function () {
    "use strict";

    var ROOT_ID = "feelawsm-sleep-funnel";
    var root = document.getElementById(ROOT_ID);
    if (!root) {
        return;
    }
    if (root.dataset.kemInit === "1") {
        return;
    }
    root.dataset.kemInit = "1";
    document.documentElement.classList.add("kem-js");

    var funnelCfg = {};
    var cfgEl = document.getElementById("FeelawsmSleepFunnelConfig");
    if (cfgEl && cfgEl.textContent) {
        try {
            funnelCfg = JSON.parse(cfgEl.textContent);
        } catch (e) {
            funnelCfg = {};
        }
    }
    var addingLabel =
        funnelCfg && typeof funnelCfg.addingLabel === "string" && funnelCfg.addingLabel
            ? funnelCfg.addingLabel
            : "Adding…";

    // ============ SCROLL REVEAL ============
    var observerOptions = { threshold: 0.1, rootMargin: "0px 0px -40px 0px" };
    var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add("kem-in");
                revealObserver.unobserve(entry.target);
            }
        });
    }, observerOptions);
    root.querySelectorAll(".kem-reveal").forEach(function (el) {
        revealObserver.observe(el);
    });

    // ============ FAQ ACCORDION (<details>, only one open at a time) ============
    var faqItems = root.querySelectorAll(".kem-faq-item");
    faqItems.forEach(function (item) {
        item.addEventListener("toggle", function () {
            if (item.open) {
                faqItems.forEach(function (other) {
                    if (other !== item && other.open) {
                        other.open = false;
                    }
                });
            }
        });
    });

    // ============ STICKY CART SHOW/HIDE ============
    var sticky = root.querySelector("#kem-sticky");
    var hero = root.querySelector(".kem-hero");
    var ticking = false;
    function setStickyPadding(show) {
        root.classList.toggle("kem-has-sticky", !!show);
    }
    window.addEventListener("scroll", function () {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                var y = window.pageYOffset || document.documentElement.scrollTop;
                var threshold = hero ? (hero.offsetTop + hero.offsetHeight - 120) : 600;
                if (sticky) {
                    if (y > threshold) {
                        sticky.classList.add("kem-show");
                        setStickyPadding(true);
                    } else {
                        sticky.classList.remove("kem-show");
                        setStickyPadding(false);
                    }
                }
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    // ============ SMOOTH ANCHOR SCROLL (offset for sticky bar) ============
    root.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
            var href = anchor.getAttribute("href");
            if (!href || href.length < 2 || href === "#") {
                return;
            }
            var target = document.querySelector(href);
            if (!target) {
                return;
            }
            e.preventDefault();
            var top = target.getBoundingClientRect().top + window.pageYOffset - 60;
            window.scrollTo({ top: top, behavior: "smooth" });
        });
    });

    // ============ INGREDIENTS "SHOW ALL" TOGGLE ============
    var blocksToggle = root.querySelector(".kem-blocks-toggle button");
    var blocksWrap = root.querySelector(".kem-blocks");
    if (blocksToggle && blocksWrap) {
        blocksToggle.addEventListener("click", function () {
            var open = blocksWrap.classList.toggle("kem-show-all");
            blocksToggle.textContent = open
                ? (blocksToggle.dataset.lessLabel || "Show fewer ingredients ↑")
                : (blocksToggle.dataset.moreLabel || "See all 9 ingredients ↓");
        });
    }

    // ============ SLEEP LEVEL CALCULATOR ============
    // 5 inputs → score (0-100) + 4-tier category + tailored recommendation
    var calcBtn = root.querySelector(".kem-calc-btn");
    if (calcBtn) {
        calcBtn.addEventListener("click", function () {
            // 1) Hours slept (typical night)
            var hoursEl = root.querySelector("#kem-calc-hours");
            var hours = parseFloat(hoursEl && hoursEl.value);
            if (isNaN(hours)) hours = 6;

            // 2) Night-time wake-ups (per night)
            var wakeEl = root.querySelector("#kem-calc-wakes");
            var wakes = parseInt(wakeEl && wakeEl.value, 10);
            if (isNaN(wakes)) wakes = 2;

            // 3) Age
            var ageEl = root.querySelector("#kem-calc-age");
            var age = parseInt(ageEl && ageEl.value, 10);
            if (isNaN(age)) age = 42;

            // 4) Hormonal symptoms (none / mild / strong)
            var horm = (root.querySelector('input[name="kem-horm"]:checked') || {}).value || "mild";

            // 5) Stress level (low / medium / high)
            var stressEl = root.querySelector("#kem-calc-stress");
            var stress = (stressEl && stressEl.value) || "medium";

            // SCORE — start at 100, deduct for each risk factor
            var base = 100;

            // Hours: ideal 7–9
            if (hours >= 7 && hours <= 9) base -= 0;
            else if (hours >= 6 && hours < 7) base -= 8;
            else if (hours >= 5 && hours < 6) base -= 18;
            else if (hours < 5) base -= 28;
            else if (hours > 9) base -= 6; // oversleeping = also a sign

            // Wake-ups
            if (wakes <= 0) base -= 0;
            else if (wakes === 1) base -= 6;
            else if (wakes === 2) base -= 14;
            else if (wakes === 3) base -= 22;
            else base -= 28;

            // Age (sleep architecture changes)
            if (age >= 50) base -= 10;
            else if (age >= 45) base -= 7;
            else if (age >= 40) base -= 5;
            else if (age >= 35) base -= 2;

            // Hormonal symptoms
            if (horm === "mild") base -= 6;
            else if (horm === "strong") base -= 16;

            // Stress
            if (stress === "medium") base -= 5;
            else if (stress === "high") base -= 13;

            base = Math.max(8, Math.min(100, Math.round(base)));

            var scoreEl = root.querySelector("#kem-result-score");
            var catEl   = root.querySelector("#kem-result-cat");
            var msgEl   = root.querySelector("#kem-result-msg");
            var boostEl = root.querySelector("#kem-boost");
            var fillEl  = root.querySelector("#kem-prog-fill");
            var panel   = root.querySelector("#kem-result");

            if (scoreEl) scoreEl.textContent = base + "%";
            if (fillEl) {
                fillEl.style.width = base + "%";
                if (base >= 75)      fillEl.style.background = "linear-gradient(90deg,#5A8A5A,#7AB87A)";
                else if (base >= 55) fillEl.style.background = "linear-gradient(90deg,#C4973A,#E8C06A)";
                else                  fillEl.style.background = "linear-gradient(90deg,#B8446A,#E890B0)";
            }

            var cat, msg, boost;
            if (base >= 80) {
                cat   = "🟢 Restorative Sleep";
                msg   = "Your sleep is mostly working for you. The ingredients in Schlaf Esenz are designed to keep it that way — Magnesium Bisglycinate for muscle relaxation, low-dose Melatonin (0.5mg) to keep your rhythm steady, and L-Theanine to quiet evening mental chatter.";
                boost = "💡 Recommendation: 1 capsule, 30 min before bed. The 1-month supply is enough to keep your current sleep quality protected as your body shifts.";
            } else if (base >= 60) {
                cat   = "🟡 Mildly Disrupted";
                msg   = "Your sleep is starting to slip — likely a mix of harder falling asleep, occasional 3am wake-ups, and waking less refreshed than you used to. This is the classic 35–45 hormonal-shift pattern.";
                boost = "💡 Recommendation: 1 capsule daily for 6–8 weeks. The 3-month bundle is the right length — most women feel a real shift by week 2, and the deeper hormonal effects build through weeks 3–6.";
            } else if (base >= 40) {
                cat   = "🟠 Significantly Disrupted";
                msg   = "Your sleep architecture is clearly disrupted — wake-ups, foggy mornings, the 3pm crash. The 9 ingredients in Schlaf Esenz address all the layers at once: Valerian + Passionflower for staying asleep, B6 + Magnesium for hormonal support, 5-HTP for waking clear.";
                boost = "💡 Recommendation: 1 capsule daily for at least 12 weeks. The 3-month bundle (most popular) gives your body the runway to settle. Nights 1–3 you feel calmer; weeks 1–2 you sleep through; weeks 3–6 hormones rebalance.";
            } else {
                cat   = "🔴 Severely Disrupted";
                msg   = "Your sleep is in survival mode — and it's affecting energy, focus, and mood every single day. This level usually means multiple drivers are stacked: hormonal shift, high stress, and low magnesium status. One ingredient won't fix it.";
                boost = "💡 Recommendation: Start the 3-month bundle today and stay on it. The full 9-ingredient formula working together is what this level needs. The 60-day money-back guarantee covers you while it builds.";
            }
            if (catEl)   catEl.textContent   = cat;
            if (msgEl)   msgEl.textContent   = msg;
            if (boostEl) boostEl.textContent = boost;
            if (panel) {
                panel.classList.add("kem-show");
                panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        });
    }

    // ============ CART DRAWER INTEGRATION (Dawn pattern — mirrors product-form.js) ============
    function getCartUi() {
        return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }

    function getCartAddUrl() {
        var cartAddPath =
            typeof routes !== "undefined" && routes.cart_add_url
                ? String(routes.cart_add_url)
                : "/cart/add";
        if (cartAddPath.charAt(0) === "/" && cartAddPath.indexOf("cart") !== -1) {
            return cartAddPath.replace(/\/cart\/add\/?$/, "/cart/add.js");
        }
        return "/cart/add.js";
    }

    function parseQuantity(btn) {
        var q = parseInt(btn.getAttribute("data-quantity"), 10);
        if (!isNaN(q) && q > 0) {
            return q;
        }
        return 1;
    }

    function fetchSectionHtmlForCart(cart, data, doRender) {
        if (data.sections || !cart || typeof routes === "undefined" || !routes.cart_url) {
            doRender(data);
            return Promise.resolve();
        }
        var sectionIds = cart.getSectionsToRender().map(function (s) {
            return s.id;
        });
        return Promise.all(
            sectionIds.map(function (id) {
                return fetch(routes.cart_url + "?section_id=" + id, { cache: "no-store" }).then(function (r) {
                    return r.text();
                });
            })
        )
            .then(function (htmls) {
                var sections = {};
                sectionIds.forEach(function (id, i) {
                    sections[id] = htmls[i];
                });
                doRender(Object.assign({}, data, { sections: sections }));
            })
            .catch(function () {
                doRender(data);
            });
    }

    root.querySelectorAll(".js-feelawsm-funnel-atc").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            if (btn.getAttribute("aria-disabled") === "true") {
                return;
            }

            var cart = getCartUi();
            var vid = parseInt(btn.getAttribute("data-variant-id"), 10);
            var spRaw = btn.getAttribute("data-selling-plan") || "";
            var quantity = parseQuantity(btn);

            if (!vid || isNaN(vid)) {
                alert("Missing variant");
                return;
            }

            var sellingPlanId = null;
            if (String(spRaw).trim() !== "") {
                var spNum = parseInt(spRaw, 10);
                if (!isNaN(spNum)) {
                    sellingPlanId = spNum;
                }
            }

            var item = { id: vid, quantity: quantity };
            if (sellingPlanId != null) {
                item.selling_plan = sellingPlanId;
            }

            var body = { items: [item] };
            if (cart) {
                if (typeof cart.setActiveElement === "function") {
                    cart.setActiveElement(document.activeElement);
                }
                if (sellingPlanId == null) {
                    body.sections = cart.getSectionsToRender().map(function (section) {
                        return section.id;
                    });
                    body.sections_url = window.location.pathname;
                }
            }

            var addUrl = getCartAddUrl();
            var bodyString = JSON.stringify(body);

            var previousHtml = btn.innerHTML;
            btn.innerHTML = "";
            btn.appendChild(document.createTextNode(addingLabel));
            btn.classList.add("feelawsm-funnel-atc--loading");
            btn.setAttribute("aria-busy", "true");
            btn.setAttribute("aria-disabled", "true");

            var cartAddPromise =
                sellingPlanId != null
                    ? new Promise(function (resolve, reject) {
                          var xhr = new XMLHttpRequest();
                          xhr.open("POST", addUrl, true);
                          xhr.setRequestHeader("Content-Type", "application/json");
                          xhr.setRequestHeader("Accept", "application/json");
                          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                          xhr.onload = function () {
                              if (xhr.status < 200 || xhr.status >= 400) {
                                  reject(new Error("Cart add failed: " + xhr.status));
                                  return;
                              }
                              try {
                                  resolve(JSON.parse(xhr.responseText));
                              } catch (err) {
                                  reject(err);
                              }
                          };
                          xhr.onerror = function () {
                              reject(new Error("Cart add network error"));
                          };
                          xhr.send(bodyString);
                      })
                    : fetch(addUrl, {
                          method: "POST",
                          headers: {
                              "Content-Type": "application/json",
                              Accept: "application/json",
                              "X-Requested-With": "XMLHttpRequest",
                          },
                          body: bodyString,
                      }).then(function (response) {
                          if (!response.ok) {
                              throw new Error("Cart add failed: " + response.status);
                          }
                          return response.json();
                      });

            cartAddPromise
                .then(function (response) {
                    if (response.status) {
                        if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                            publish(window.PUB_SUB_EVENTS.cartError, {
                                source: "feelawsm-sleep-funnel",
                                productVariantId: String(vid),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                        }
                        var desc = (response.description || response.message || "Could not add to cart").toString();
                        alert(desc);
                        return;
                    }

                    if (!cart) {
                        if (typeof routes !== "undefined" && routes.cart_url) {
                            window.location.href = routes.cart_url;
                        } else {
                            window.location.href = "/cart";
                        }
                        return;
                    }

                    if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                        publish(window.PUB_SUB_EVENTS.cartUpdate, {
                            source: "feelawsm-sleep-funnel",
                            productVariantId: String(vid),
                            cartData: response,
                        });
                    }
                    window.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

                    var doRender = function (data) {
                        cart.renderContents(data);
                    };

                    if (cart.classList && cart.classList.contains("is-empty")) {
                        cart.classList.remove("is-empty");
                    }

                    return fetchSectionHtmlForCart(cart, response, doRender);
                })
                .catch(function (err) {
                    console.warn("[feelawsm-sleep-funnel]", err);
                    var msg = (err && err.message) || "Could not add to cart";
                    alert(msg);
                })
                .finally(function () {
                    btn.innerHTML = previousHtml;
                    btn.classList.remove("feelawsm-funnel-atc--loading");
                    btn.removeAttribute("aria-busy");
                    btn.removeAttribute("aria-disabled");
                });
        });
    });
})();
